import { render, staticRenderFns } from "./DialogConsentCheckUserOnePlatform.vue?vue&type=template&id=231a63ca&scoped=true&"
import script from "./DialogConsentCheckUserOnePlatform.vue?vue&type=script&lang=js&"
export * from "./DialogConsentCheckUserOnePlatform.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentCheckUserOnePlatform.vue?vue&type=style&index=0&id=231a63ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a63ca",
  null
  
)

export default component.exports